import {calculateDistance, convertFootToMiles} from './distance';
import {Location} from '../hooks/useUserLocation';

/**
 * Returns a human-readable distance description from the user's location to a venue
 *
 * @param userLocation The user's current location
 * @param venueLocation The venue's location
 * @returns A formatted string like "Just steps away", "Nearby", "0.4 mi away" etc.
 */
export const getVenueDistanceText = (
  userLocation: Location | null | undefined,
  venueLocation: {latitude: number; longitude: number}
): string => {
  if (!userLocation || !venueLocation?.latitude || !venueLocation?.longitude) {
    return '';
  }

  try {
    const distanceInFeet = calculateDistance(
      {latitude: userLocation.latitude, longitude: userLocation.longitude},
      {latitude: venueLocation.latitude, longitude: venueLocation.longitude}
    );
    const distanceInMiles = convertFootToMiles(distanceInFeet);

    if (distanceInMiles > 0.1) {
      return distanceInMiles.toFixed(1) + ' mi';
    }
    return distanceInFeet.toFixed(0) + ' feet';

  } catch (error) {
    console.error('Error calculating venue distance:', error);
    return '';
  }
};

export default getVenueDistanceText;
